import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

function DFacRepar({ usuario }) {
    const [planillas, setPlanillas] = useState([]);
    const [planillasFiltradas, setPlanillasFiltradas] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);

    // Datos para los selectores
    const [sucursales, setSucursales] = useState([]);
    const [depositos, setDepositos] = useState([]);
    const [zonas, setZonas] = useState([]);
    const [empleados, setEmpleados] = useState([]);

    // Estados de selectores activos
    const [sucursalSeleccionada, setSucursalSeleccionada] = useState(null);
    const [depositoSeleccionado, setDepositoSeleccionado] = useState(null);
    const [zonaSeleccionada, setZonaSeleccionada] = useState(null);
    const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);

    // Dropdowns
    const [dropdownSucursalAbierto, setDropdownSucursalAbierto] = useState(false);
    const [dropdownDepositoAbierto, setDropdownDepositoAbierto] = useState(false);
    const [dropdownZonaAbierto, setDropdownZonaAbierto] = useState(false);
    const [dropdownEmpleadoAbierto, setDropdownEmpleadoAbierto] = useState(false);

    // Búsquedas
    const [busquedaSucursal, setBusquedaSucursal] = useState('');
    const [busquedaDeposito, setBusquedaDeposito] = useState('');
    const [busquedaZona, setBusquedaZona] = useState('');
    const [busquedaEmpleado, setBusquedaEmpleado] = useState('');

    // Refs
    const dropdownSucursalRef = useRef(null);
    const dropdownDepositoRef = useRef(null);
    const dropdownZonaRef = useRef(null);
    const dropdownEmpleadoRef = useRef(null);

    const [formulario, setFormulario] = useState({
        nreparto: '',
        idSucursal: '',
        idDeposito: '',
        idZona: '',
        idEmpleado: '',
        idLiquidacion: '',
        fecha: '',
        total: 0,
        obs: '',
        bEstado: ' '
    });

    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(10);

    const API_URL = '/api/dfacrepar';

    useEffect(() => {
        cargarPlanillas();
        cargarDatosSelectores();
    }, []);

    useEffect(() => {
        filtrarPlanillas();
    }, [busqueda, planillas]);

    // Cerrar dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownSucursalRef.current && !dropdownSucursalRef.current.contains(event.target)) {
                setDropdownSucursalAbierto(false);
            }
            if (dropdownDepositoRef.current && !dropdownDepositoRef.current.contains(event.target)) {
                setDropdownDepositoAbierto(false);
            }
            if (dropdownZonaRef.current && !dropdownZonaRef.current.contains(event.target)) {
                setDropdownZonaAbierto(false);
            }
            if (dropdownEmpleadoRef.current && !dropdownEmpleadoRef.current.contains(event.target)) {
                setDropdownEmpleadoAbierto(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const cargarDatosSelectores = async () => {
        try {
            // Cargar sucursales
            const respSucursales = await axios.get('/api/sucursales');
            setSucursales(respSucursales.data);

            // Cargar depósitos
            const respDepositos = await axios.get('/api/depositos');
            setDepositos(respDepositos.data);

            // Cargar zonas
            const respZonas = await axios.get('/api/zonas');
            setZonas(respZonas.data);

            // Cargar empleados
            const respEmpleados = await axios.get('/api/empleados');
            setEmpleados(respEmpleados.data);

        } catch (error) {
            console.error('Error al cargar datos de selectores:', error);
        }
    };

    const cargarPlanillas = async () => {
        try {
            const response = await axios.get(API_URL);
            setPlanillas(response.data);
            setPlanillasFiltradas(response.data);
        } catch (error) {
            console.error('Error al cargar planillas:', error);
            alert('Error al cargar las planillas de facturación');
        }
    };

    const filtrarPlanillas = () => {
        if (!busqueda) {
            setPlanillasFiltradas(planillas);
            setPaginaActual(1);
            return;
        }

        const filtrados = planillas.filter(planilla =>
            planilla.nreparto?.toString().includes(busqueda) ||
            planilla.obs?.toLowerCase().includes(busqueda.toLowerCase())
        );
        setPlanillasFiltradas(filtrados);
        setPaginaActual(1);
    };

    // Funciones para selectores
    const filtrarSucursales = (busq) => {
        if (!busq) return sucursales;
        return sucursales.filter(s =>
            s.idSucursal?.toString().includes(busq) ||
            s.nombre?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarSucursal = (sucursal) => {
        setSucursalSeleccionada(sucursal);
        setFormulario({ ...formulario, idSucursal: sucursal.idSucursal });
        setBusquedaSucursal('');
        setDropdownSucursalAbierto(false);
    };

    const filtrarDepositos = (busq) => {
        if (!busq) return depositos;
        return depositos.filter(d =>
            d.idDeposito?.toString().includes(busq) ||
            d.nomDepto?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarDeposito = (deposito) => {
        setDepositoSeleccionado(deposito);
        setFormulario({ ...formulario, idDeposito: deposito.idDeposito });
        setBusquedaDeposito('');
        setDropdownDepositoAbierto(false);
    };

    const filtrarZonas = (busq) => {
        if (!busq) return zonas;
        return zonas.filter(z =>
            z.idZona?.toString().includes(busq) ||
            z.nomZona?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarZona = (zona) => {
        setZonaSeleccionada(zona);
        setFormulario({ ...formulario, idZona: zona.idZona });
        setBusquedaZona('');
        setDropdownZonaAbierto(false);
    };

    const filtrarEmpleados = (busq) => {
        if (!busq) return empleados.slice(0, 100);
        return empleados.filter(e =>
            e.idEmpleado?.toString().includes(busq) ||
            e.nombre?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarEmpleado = (empleado) => {
        setEmpleadoSeleccionado(empleado);
        setFormulario({ ...formulario, idEmpleado: empleado.idEmpleado });
        setBusquedaEmpleado('');
        setDropdownEmpleadoAbierto(false);
    };

    // Función para formatear fecha de YYYY-MM-DD a DD/MM/YYYY
    const formatearFechaParaMostrar = (fecha) => {
        if (!fecha) return '';
        const [year, month, day] = fecha.split('-');
        return `${day}/${month}/${year}`;
    };

    // Función para formatear fecha de DD/MM/YYYY a YYYY-MM-DD
    const formatearFechaParaDB = (fecha) => {
        if (!fecha) return '';
        const [day, month, year] = fecha.split('/');
        return `${year}-${month}-${day}`;
    };

    const abrirModalNuevo = () => {
        setFormulario({
            nreparto: '',
            idSucursal: '',
            idDeposito: '',
            idZona: '',
            idEmpleado: '',
            idLiquidacion: '',
            fecha: '',
            total: 0,
            obs: '',
            bEstado: ' '
        });

        // Limpiar selectores
        setSucursalSeleccionada(null);
        setDepositoSeleccionado(null);
        setZonaSeleccionada(null);
        setEmpleadoSeleccionado(null);

        setModoEdicion(false);
        setModalAbierto(true);
    };

    const abrirModalEditar = (planilla) => {
        setFormulario({
            nreparto: planilla.nreparto,
            idSucursal: planilla.idSucursal || '',
            idDeposito: planilla.idDeposito || '',
            idZona: planilla.idZona || '',
            idEmpleado: planilla.idEmpleado || '',
            idLiquidacion: planilla.idLiquidacion || '',
            fecha: planilla.fecha || '',
            total: planilla.total || 0,
            obs: planilla.obs || '',
            bEstado: planilla.bEstado || ' '
        });

        // Buscar y establecer los objetos seleccionados
        if (planilla.idSucursal) {
            const sucursal = sucursales.find(s => s.idSucursal === planilla.idSucursal);
            setSucursalSeleccionada(sucursal || null);
        } else {
            setSucursalSeleccionada(null);
        }

        if (planilla.idDeposito) {
            const deposito = depositos.find(d => d.idDeposito === planilla.idDeposito);
            setDepositoSeleccionado(deposito || null);
        } else {
            setDepositoSeleccionado(null);
        }

        if (planilla.idZona) {
            const zona = zonas.find(z => z.idZona === planilla.idZona);
            setZonaSeleccionada(zona || null);
        } else {
            setZonaSeleccionada(null);
        }

        if (planilla.idEmpleado) {
            const empleado = empleados.find(e => e.idEmpleado === planilla.idEmpleado);
            setEmpleadoSeleccionado(empleado || null);
        } else {
            setEmpleadoSeleccionado(null);
        }

        setModoEdicion(true);
        setModalAbierto(true);
    };

    const cerrarModal = () => {
        setModalAbierto(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const planillaData = { ...formulario };

            if (modoEdicion) {
                await axios.put(`${API_URL}/${formulario.nreparto}`, planillaData);
                alert('Planilla actualizada exitosamente');
            } else {
                // Registrar el usuario que crea la planilla
                planillaData.creadoPor = usuario || '';
                await axios.post(API_URL, planillaData);
                alert('Planilla creada exitosamente');
            }
            cargarPlanillas();
            cerrarModal();
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar la planilla de facturación');
        }
    };

    const cerrarPlanilla = async (planilla) => {
        if (planilla.bEstado === 'C') {
            alert('La planilla ya se encuentra cerrada');
            return;
        }
        if (!window.confirm(
            'Esta seguro de CERRAR la planilla N° ' + planilla.nreparto + '?\n\n' +
            'Una vez cerrada NO podra:\n' +
            '  - Modificar ningun campo (ni siquiera la observacion)\n' +
            '  - Agregar facturas a la planilla\n' +
            '  - Reabrirla'
        )) return;
        try {
            await axios.put(`${API_URL}/${planilla.nreparto}/cerrar`);
            alert('Planilla cerrada exitosamente');
            cargarPlanillas();
        } catch (error) {
            const msg = error.response?.data || 'Error al cerrar la planilla';
            alert(typeof msg === 'string' ? msg : 'Error al cerrar la planilla');
        }
    };

    const exportarExcel = () => {
        const datosExportar = planillasFiltradas.map(planilla => ({
            'Nº Reparto': planilla.nreparto,
            'Sucursal': planilla.idSucursal,
            'Depósito': planilla.idDeposito,
            'Zona': planilla.idZona,
            'Empleado': planilla.idEmpleado,
            'Fecha': planilla.fecha,
            'Total': planilla.total,
            'Observaciones': planilla.obs,
            'Estado': planilla.bEstado,
            'Creado por': planilla.creadoPor
        }));

        const worksheet = XLSX.utils.json_to_sheet(datosExportar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Planillas');
        XLSX.writeFile(workbook, 'planillas_facturacion.xlsx');
    };

    // Paginación
    const indiceUltimo = paginaActual * itemsPorPagina;
    const indicePrimero = indiceUltimo - itemsPorPagina;
    const planillasActuales = planillasFiltradas.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(planillasFiltradas.length / itemsPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
    };

    const cambiarItemsPorPagina = (e) => {
        setItemsPorPagina(Number(e.target.value));
        setPaginaActual(1);
    };

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Planilla de Facturación</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        className="input-busqueda"
                        placeholder="Buscar..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>
                        ➕ Nueva Planilla
                    </button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>
                        📊 Exportar a Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            <th>Nº Reparto</th>
                            <th>Sucursal</th>
                            <th>Depósito</th>
                            <th>Zona</th>
                            <th>Empleado</th>
                            <th>Fecha</th>
                            <th>Total</th>
                            <th>Observaciones</th>
                            <th>Estado</th>
                            <th>Creado por</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {planillasActuales.length === 0 ? (
                            <tr>
                                <td colSpan="11" className="sin-datos">No hay planillas para mostrar</td>
                            </tr>
                        ) : (
                            planillasActuales.map(planilla => (
                                <tr key={planilla.nreparto}>
                                    <td>{planilla.nreparto}</td>
                                    <td>{planilla.idSucursal}</td>
                                    <td>{planilla.idDeposito}</td>
                                    <td>{planilla.idZona}</td>
                                    <td>{planilla.idEmpleado}</td>
                                    <td>{planilla.fecha ? formatearFechaParaMostrar(planilla.fecha) : ''}</td>
                                    <td style={{ textAlign: 'right' }}>{planilla.total?.toLocaleString('es-PY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                    <td>{planilla.obs}</td>
                                    <td>{planilla.bEstado}</td>
                                    <td style={{ fontSize: '12px', color: '#555' }}>{planilla.creadoPor || '-'}</td>
                                    <td>
                                        <button
                                            onClick={() => abrirModalEditar(planilla)}
                                            className="btn-accion"
                                            title={planilla.bEstado === 'C' ? 'No se puede editar - Planilla Cerrada' : 'Modificar (solo Observaciones)'}
                                            disabled={planilla.bEstado === 'C'}
                                            style={planilla.bEstado === 'C' ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            onClick={() => cerrarPlanilla(planilla)}
                                            className="btn-accion"
                                            title={planilla.bEstado === 'C' ? 'Planilla ya cerrada' : 'Cerrar planilla'}
                                            disabled={planilla.bEstado === 'C'}
                                            style={planilla.bEstado === 'C' ? { opacity: 0.5, cursor: 'not-allowed' } : { color: '#d97706' }}
                                        >
                                            🔒
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Paginación */}
            <div className="paginacion-container">
                <div className="paginacion-info">
                    <span>
                        Mostrando {indicePrimero + 1} a {Math.min(indiceUltimo, planillasFiltradas.length)} de {planillasFiltradas.length} registros
                    </span>
                    <select value={itemsPorPagina} onChange={cambiarItemsPorPagina} className="select-registros">
                        <option value={5}>5 por página</option>
                        <option value={10}>10 por página</option>
                        <option value={20}>20 por página</option>
                        <option value={50}>50 por página</option>
                    </select>
                </div>

                <div className="paginacion-controles">
                    <button onClick={() => cambiarPagina(1)} disabled={paginaActual === 1} className="btn-paginacion">⏮️</button>
                    <button onClick={() => cambiarPagina(paginaActual - 1)} disabled={paginaActual === 1} className="btn-paginacion">◀️</button>

                    {[...Array(totalPaginas)].map((_, index) => {
                        const numeroPagina = index + 1;
                        if (numeroPagina === 1 || numeroPagina === totalPaginas || (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)) {
                            return (
                                <button key={numeroPagina} onClick={() => cambiarPagina(numeroPagina)} className={`btn-numero-pagina ${paginaActual === numeroPagina ? 'activo' : ''}`}>
                                    {numeroPagina}
                                </button>
                            );
                        } else if (numeroPagina === paginaActual - 2 || numeroPagina === paginaActual + 2) {
                            return <span key={numeroPagina}>...</span>;
                        }
                        return null;
                    })}

                    <button onClick={() => cambiarPagina(paginaActual + 1)} disabled={paginaActual === totalPaginas} className="btn-paginacion">▶️</button>
                    <button onClick={() => cambiarPagina(totalPaginas)} disabled={paginaActual === totalPaginas} className="btn-paginacion">⏭️</button>
                </div>
            </div>

            {/* Modal con formulario */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido" style={{ maxWidth: '800px', maxHeight: '90vh', overflowY: 'auto' }}>
                        <div className="modal-header">
                            <h3>{modoEdicion ? 'Editar Planilla' : 'Nueva Planilla'}</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">×</button>
                        </div>
                        {modoEdicion && formulario.bEstado === 'C' && (
                            <div style={{
                                padding: '10px',
                                backgroundColor: '#fff3cd',
                                border: '1px solid #ffc107',
                                borderRadius: '4px',
                                margin: '10px 0',
                                color: '#856404'
                            }}>
                                ⚠️ Esta planilla está cerrada y no se puede modificar
                            </div>
                        )}
                        {modoEdicion && formulario.bEstado !== 'C' && (
                            <div style={{
                                padding: '10px',
                                backgroundColor: '#e7f3ff',
                                border: '1px solid #2DCCD3',
                                borderRadius: '4px',
                                margin: '10px 0',
                                color: '#001A70'
                            }}>
                                ℹ️ En modo edición solo se puede modificar el campo <strong>Observaciones</strong>. El resto de campos son de solo lectura.
                            </div>
                        )}
                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                {/* Columna 1 */}
                                <div>
                                    {/* Sucursal */}
                                    <div className="form-group">
                                        <label>Sucursal *</label>
                                        <div className="cuenta-selector" ref={dropdownSucursalRef}>
                                            {sucursalSeleccionada ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{sucursalSeleccionada.idSucursal} - {sucursalSeleccionada.nombre}</span>
                                                    <button type="button" onClick={() => { setSucursalSeleccionada(null); setFormulario({...formulario, idSucursal: ''}); }} className="btn-limpiar" disabled={modoEdicion}>✕</button>
                                                </div>
                                            ) : (
                                                <input
                                                    type="text"
                                                    placeholder="Buscar sucursal..."
                                                    value={busquedaSucursal}
                                                    onChange={(e) => setBusquedaSucursal(e.target.value)}
                                                    onFocus={() => !modoEdicion && (!formulario.bEstado || formulario.bEstado !== 'C') ? setDropdownSucursalAbierto(true) : null}
                                                    className="input-busqueda"
                                                    disabled={modoEdicion || formulario.bEstado === 'C'}
                                                />
                                            )}
                                            {dropdownSucursalAbierto && !sucursalSeleccionada && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarSucursales(busquedaSucursal).map(sucursal => (
                                                        <div key={sucursal.idSucursal} className="cuenta-item" onClick={() => seleccionarSucursal(sucursal)}>
                                                            <strong>{sucursal.idSucursal}</strong> - {sucursal.nombre}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Depósito */}
                                    <div className="form-group">
                                        <label>Depósito</label>
                                        <div className="cuenta-selector" ref={dropdownDepositoRef}>
                                            {depositoSeleccionado ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{depositoSeleccionado.idDeposito} - {depositoSeleccionado.nomDepto}</span>
                                                    <button type="button" onClick={() => { setDepositoSeleccionado(null); setFormulario({...formulario, idDeposito: ''}); }} className="btn-limpiar" disabled={modoEdicion}>✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar depósito..." value={busquedaDeposito} onChange={(e) => setBusquedaDeposito(e.target.value)} onFocus={() => !modoEdicion && formulario.bEstado !== 'C' && setDropdownDepositoAbierto(true)} className="input-busqueda" disabled={modoEdicion || formulario.bEstado === 'C'} />
                                            )}
                                            {dropdownDepositoAbierto && !depositoSeleccionado && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarDepositos(busquedaDeposito).map(deposito => (
                                                        <div key={deposito.idDeposito} className="cuenta-item" onClick={() => seleccionarDeposito(deposito)}>
                                                            <strong>{deposito.idDeposito}</strong> - {deposito.nomDepto}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Zona */}
                                    <div className="form-group">
                                        <label>Zona</label>
                                        <div className="cuenta-selector" ref={dropdownZonaRef}>
                                            {zonaSeleccionada ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{zonaSeleccionada.idZona} - {zonaSeleccionada.nomZona}</span>
                                                    <button type="button" onClick={() => { setZonaSeleccionada(null); setFormulario({...formulario, idZona: ''}); }} className="btn-limpiar" disabled={modoEdicion}>✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar zona..." value={busquedaZona} onChange={(e) => setBusquedaZona(e.target.value)} onFocus={() => !modoEdicion && formulario.bEstado !== 'C' && setDropdownZonaAbierto(true)} className="input-busqueda" disabled={modoEdicion || formulario.bEstado === 'C'} />
                                            )}
                                            {dropdownZonaAbierto && !zonaSeleccionada && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarZonas(busquedaZona).map(zona => (
                                                        <div key={zona.idZona} className="cuenta-item" onClick={() => seleccionarZona(zona)}>
                                                            <strong>{zona.idZona}</strong> - {zona.nomZona}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Fecha */}
                                    <div className="form-group">
                                        <label>Fecha</label>
                                        <input
                                            type="date"
                                            value={formulario.fecha}
                                            onChange={(e) => setFormulario({...formulario, fecha: e.target.value})}
                                            className="input-fecha"
                                            disabled={modoEdicion || formulario.bEstado === 'C'}
                                        />
                                    </div>
                                </div>

                                {/* Columna 2 */}
                                <div>
                                    {/* Empleado */}
                                    <div className="form-group">
                                        <label>Empleado</label>
                                        <div className="cuenta-selector" ref={dropdownEmpleadoRef}>
                                            {empleadoSeleccionado ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{empleadoSeleccionado.idEmpleado} - {empleadoSeleccionado.nombre}</span>
                                                    <button type="button" onClick={() => { setEmpleadoSeleccionado(null); setFormulario({...formulario, idEmpleado: ''}); }} className="btn-limpiar" disabled={modoEdicion}>✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar empleado..." value={busquedaEmpleado} onChange={(e) => setBusquedaEmpleado(e.target.value)} onFocus={() => !modoEdicion && formulario.bEstado !== 'C' && setDropdownEmpleadoAbierto(true)} className="input-busqueda" disabled={modoEdicion || formulario.bEstado === 'C'} />
                                            )}
                                            {dropdownEmpleadoAbierto && !empleadoSeleccionado && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarEmpleados(busquedaEmpleado).map(empleado => (
                                                        <div key={empleado.idEmpleado} className="cuenta-item" onClick={() => seleccionarEmpleado(empleado)}>
                                                            <strong>{empleado.idEmpleado}</strong> - {empleado.nombre}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Total */}
                                    <div className="form-group">
                                        <label>Total</label>
                                        <input
                                            type="text"
                                            value={formulario.total?.toLocaleString('es-PY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0,00'}
                                            readOnly
                                            disabled
                                            style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
                                        />
                                    </div>

                                    {/* Estado (solo lectura) */}
                                    <div className="form-group">
                                        <label>Estado</label>
                                        <input
                                            type="text"
                                            value={formulario.bEstado}
                                            readOnly
                                            disabled
                                            style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Observaciones - campo completo ancho */}
                            <div className="form-group">
                                <label>Observaciones</label>
                                <textarea
                                    value={formulario.obs}
                                    onChange={(e) => setFormulario({...formulario, obs: e.target.value})}
                                    maxLength={40}
                                    placeholder="Observaciones"
                                    rows={3}
                                    style={{ width: '100%', resize: 'vertical' }}
                                    disabled={formulario.bEstado === 'C'}
                                />
                            </div>

                            <div className="modal-footer">
                                <button type="button" onClick={cerrarModal} className="btn btn-cancelar">Cancelar</button>
                                <button
                                    type="submit"
                                    className="btn btn-guardar"
                                    disabled={formulario.bEstado === 'C'}
                                    style={formulario.bEstado === 'C' ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                >
                                    {modoEdicion ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default DFacRepar;
